/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract the new value from the original value, divide by the original value, then multiply by 100.`)
};

const es_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resta el valor nuevo del valor original, divide entre el valor original y multiplica por 100.`)
};

const de_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe den neuen Wert vom Ausgangswert ab, teile das Ergebnis durch den Ausgangswert und multipliziere mit 100.`)
};

const nl_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trek de nieuwe waarde af van de oorspronkelijke waarde, deel door de oorspronkelijke waarde en vermenigvuldig met 100.`)
};

const fr_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustrayez la nouvelle valeur de la valeur d'origine, divisez par la valeur d'origine, puis multipliez par 100.`)
};

const it_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrai il nuovo valore dal valore originale, dividi per il valore originale, poi moltiplica per 100.`)
};

const pt_br2_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia o novo valor do valor original, divida pelo valor original e depois multiplique por 100.`)
};

const pt_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtraia o novo valor do valor original, divida pelo valor original e depois multiplique por 100.`)
};

const ja_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元の値から新しい値を引き、元の値で割ってから100を掛けます。`)
};

const zh_pct_decrease_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用原始值减去新值，除以原始值，再乘以 100。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_faq1_a", locale)
	if (locale === "en") return en_pct_decrease_faq1_a(inputs)
	if (locale === "es") return es_pct_decrease_faq1_a(inputs)
	if (locale === "de") return de_pct_decrease_faq1_a(inputs)
	if (locale === "nl") return nl_pct_decrease_faq1_a(inputs)
	if (locale === "fr") return fr_pct_decrease_faq1_a(inputs)
	if (locale === "it") return it_pct_decrease_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_faq1_a(inputs)
	if (locale === "pt") return pt_pct_decrease_faq1_a(inputs)
	if (locale === "ja") return ja_pct_decrease_faq1_a(inputs)
	return zh_pct_decrease_faq1_a(inputs)
};